import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import AdminNavbar from '../admin/admin_navbar';
import AdminSidebar from '../admin/admin_sidebar';
import AdminFooter from '../admin/admin_dashboard';

export default function AdminLayout() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#EBE0CF] font-poppins">

      {/* Navbar */}
      <AdminNavbar />

      {/* Main Content */}
      <div className="flex w-full bg-[#EBE0CF]">

        {/* Sidebar */}
        <AdminSidebar />

        {/* Dashboard Content */}
        <div className="flex-1 p-8 bg-[#EBE0CF] min-h-[calc(100vh-64px)]">
          <AdminFooter />
        </div>

      </div>

      {/* Footer Button */}
      <div className="w-full bg-[#0B2A2C] py-6 flex justify-center items-center">
        <Link
          to="/admin/settings"
          className="px-8 py-3 bg-[#FFE286] text-[#0B2A2C] font-semibold rounded-full shadow-md hover:bg-yellow-400 transition"
        >
          Go to Admin Settings →
        </Link>
      </div>

    </div>
  );
}
